export enum Flipper {
  ShiftManagmentMinStaffedHours = 'shift_managment_min_staffed_hours',
  DisableDevicePrioritization = 'disable_device_prioritization',
  PerformanceOverviewDisabled = 'performance_overview_disabled',
  PlatformOnly = 'platform_only',
  ScalableTraining = 'scalable_training',
  ultrafastCrossDayDeliveryEnabled = 'ultrafast_cross_day_delivery_enabled',
  WarehouseLocationPickupHourEnabled = 'rt_whl_pickup_hour_enabled',
  RunnerDevicePrioritizationEnabled = 'rt_runner_device_prioritization',
}
